import type { Highcharts } from "./useHighcharts"

// Find the nearest data point for a given X value
export const findPointAtX = (chart: Highcharts.Chart, clickedX: number) => {
  const allXValues: number[] = []
  chart.series.forEach((series) => {
    series.points?.forEach((point) => {
      if (!allXValues.includes(point.x)) {
        allXValues.push(point.x)
      }
    })
  })

  if (allXValues.length === 0) {
    return null
  }

  const nearestX = allXValues.reduce((prev, curr) =>
    Math.abs(curr - clickedX) < Math.abs(prev - clickedX) ? curr : prev
  )

  // Find a point at that X to use for extraction
  let pointAtX: Highcharts.Point | undefined
  for (const series of chart.series) {
    pointAtX = series.points?.find((p) => p.x === nearestX)
    if (pointAtX) break
  }

  if (!pointAtX) {
    console.warn("No point found at X:", nearestX)
    return
  }

  return pointAtX
}
